import { render, staticRenderFns } from "./WidgetParticipants.vue?vue&type=template&id=aba81dd2&"
import script from "./WidgetParticipants.vue?vue&type=script&lang=js&"
export * from "./WidgetParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports